// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".FooterBreadcrumbs-module-listContainer-SB3o2{display:flex;align-items:center}.FooterBreadcrumbs-module-breadcrumbs-23pWK{display:none}@media(min-width: 768px){.FooterBreadcrumbs-module-breadcrumbs-23pWK{display:flex}}.FooterBreadcrumbs-module-logo-3t0dx{display:flex;margin-inline-end:var(--des-dimension-gap-and-padding-general-near-large);width:56px}", ""]);
// Exports
exports.locals = {
	"listContainer": "FooterBreadcrumbs-module-listContainer-SB3o2",
	"breadcrumbs": "FooterBreadcrumbs-module-breadcrumbs-23pWK",
	"logo": "FooterBreadcrumbs-module-logo-3t0dx"
};
module.exports = exports;
